import { useQuery } from '@tanstack/react-query';
import {
  fetchReferralActivity,
  fetchReferralCode,
  fetchReferralEarnings,
  fetchReferralHistory,
  fetchReferralMe,
  fetchReferralSummary,
  fetchReferrals,
} from './request';
import { referralKeys } from './key';

export const useReferralMe = () =>
  useQuery({
    queryKey: referralKeys.me(),
    queryFn: fetchReferralMe,
  });

export const useReferralCode = () =>
  useQuery({
    queryKey: referralKeys.code(),
    queryFn: fetchReferralCode,
  });

export const useReferralSummary = () =>
  useQuery({
    queryKey: referralKeys.summary(),
    queryFn: fetchReferralSummary,
  });

export const useReferrals = () =>
  useQuery({
    queryKey: referralKeys.referrals(),
    queryFn: fetchReferrals,
  });

export const useReferralActivity = () =>
  useQuery({
    queryKey: referralKeys.activity(),
    queryFn: fetchReferralActivity,
  });

export const useReferralHistory = () =>
  useQuery({
    queryKey: referralKeys.history(),
    queryFn: fetchReferralHistory,
  });

export const useReferralEarnings = () =>
  useQuery({
    queryKey: referralKeys.earnings(),
    queryFn: fetchReferralEarnings,
  });
